import { WinnerEventRequest } from '../../models/schemas';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createWinnerEvent: (
  fetchContext: FetchContext,
  programId: number,
  winnerEvent: WinnerEventRequest,
  accessToken?: string,
) => Promise<void> = (fetchContext, programId, winnerEvent, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/winner-events`,
  {
    method: 'POST',
    body: JSON.stringify(winnerEvent),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'create winner event'));
